/*
 * Copyright (c) 2024 Amazon.com, Inc. All Rights Reserved.
 */
import "bootstrap/dist/css/bootstrap.css";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {ModelPage} from "./components/models/ModelPage";
import {CommitHistoryPage} from "./components/commit-history/CommitHistoryPage";
import {AntiSignaturePage} from "./components/antisignatures/AntiSignaturePage";

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <Routes>
                <Route path="/*" element={<ModelPage/>}/>
                <Route path="/commits" element={<CommitHistoryPage/>}/>
                <Route path="/antisignatures" element={<AntiSignaturePage/>}/>
            </Routes>
        </BrowserRouter>
    </React.StrictMode>
);